module.exports = __webpack_public_path__ + "img/support.ed9f2f49.svg";